import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {UserSignalRequest} from 'libs/data-access/telemetry/src/lib/models/user-signal.model';
import {ServiceManagerHttpService} from 'libs/shared/http/src/lib/services/http/http.service';

const signalsUrl = '/Telemetry/Signals';

@Injectable({providedIn: 'root'})
export class TelemetryDataService {
    private readonly httpService = inject(ServiceManagerHttpService);

    postSignals(request: UserSignalRequest): Observable<void> {
        return this.httpService.post<void>(signalsUrl, request);
    }

    // Uses fetch with keepalive for reliable data transmission during page unload.
    postSignalsBeacon(request: UserSignalRequest): boolean {
        return this.httpService.sendBeacon(signalsUrl, request, 'POST');
    }
}
